<template>
  <div class="m-main">
    <Banner :click="bannerClickHandler"></Banner>
    <Loading v-if="!dataLoaded"></Loading>
    <template v-else>
      <div class="m-author"
        :class="{'m-author-image': author.imageUrl}"
        :style="{backgroundImage: author.imageUrl ? `url(${author.imageUrl})` : null}"
      >
        <div class="m-author__name">{{author.name}}</div>
        <div class="m-author__line"></div>
      </div>
      <div class="m-intro">{{author.description}}</div>
      <div class="m-work">
        <h2>全部作品</h2>
        <div class="m-work__list">
          <div class="m-work__empty" v-if="!books.length">该作者暂时还没有作品收录哦~</div>
          <div class="m-book" v-for="(item, index) in books " :key="index" @click="bookClickHandler(item.book.strBookId)">
            <img :src="item.book.imageUrl" alt="书籍封面" class="m-book__cover">
            <h3 class="m-book__name">{{item.book.title}}</h3>
            <div class="m-book__reader">{{formatNumber(item.readerCount)}}人在读</div>
            <div class="m-book__desc">{{item.book.description}}</div>
          </div>
        </div>
        <div class="m-work__open" v-if="bookCount > books.length" @click="openClickHandler">打开APP，查看更多作品</div>
      </div>
      <Divider></Divider>
      <user-invite v-if="uuid" :uuid="uuid" :copyHandler="copyHandler"></user-invite>
      <Bottom :logHandler="downloadLogHandler"></Bottom>
    </template>
  </div>
</template>

<script>
import getEnvInfo from 'snail-env'
import Log from 'snail-log'
import {openAppSnail} from 'nw-app-snail'
import {setOrUpdate} from 'nw-share'
import parseUrl from '../../../js/utils/parseUrl.js'
import {customFormatNumber} from 'nw-toolkits/es/number-format'
import {trace} from 'snail-trace'

import Banner from '../../../vue-components/components/Banner'
import Loading from '../../../vue-components/components/Loading'
import Divider from '../../../vue-components/components/Divider'
import UserInvite from '../../../vue-components/components/UserInvite'
import Bottom from '../../../vue-components/components/Bottom'

export default {
  name: 'author',
  components: {
    Banner,
    Loading,
    Divider,
    UserInvite,
    Bottom,
  },
  data() {
    return {
      uuid: getEnvInfo().env === 'online' ? 'ea692b2fe1da4eb0a295f8f4ab5b992e' : '479bcf687d0e4f369072c60681c0a2a6',
      dataLoaded: false,
      authorId: '',
      author: null,
      books: [],
      bookCount: 0
    }
  },
  created(){
    //traceId上报
    trace();
    this.isSnail = navigator.userAgent.match(/NeteaseSnailReader[^/]*\/(\d[.\d]+).*\((.*);(.*)\)/i);
    const match = location.href.match(/\/author\/(\d+)/);
    if(match && match[1]){
      this.authorId = match[1];
      this.envInfo = getEnvInfo();
      const urlData = parseUrl();
      if(urlData && urlData.user){
        this.uuid = urlData.user;
      }
      if(this.isSnail){
        this.openApp();
      }
      this.log = new Log('h5');
      this.getDetail();
      this.getBooks();
    }else{
      location.href = '/404';
    }
  },
  methods: {
    openApp(){
      openAppSnail({
        path: 'author',
        query: {
          authorId: this.authorId
        }
      })
    },
    bannerClickHandler(){
      this.log.sendLog('a9-1', ['author_page', 'open_app', this.authorId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    },
    setShareConfig(){
      const shareConfig = {
          activityId: this.authorId,
          title: this.books.length ? `${this.author.name} |《${this.books[0].book.title}》等佳作蜗牛都有！` : `Wow！${this.author.name}的书都在蜗牛读书`,
          description: this.author.description || '网易蜗牛读书',
          text: this.books.length ? `${this.author.name} |《${this.books[0].book.title}》等佳作蜗牛都有！@网易蜗牛读书 ${location.href}` : `Wow！${this.author.name}的书都在蜗牛读书 @网易蜗牛读书 ${location.href}`,
          picurl: this.author.imageUrl ? this.author.imageUrl + '?imageView&thumbnail=200y200' : 'https://easyreadfs.nosdn.127.net/web/trunk/1513149240838/snail_logo_60ptx3x.png',
          link: location.href
      }
      setOrUpdate(shareConfig);
    },
    async getDetail(){
      try {
        const response = await this.$http.jsonp(this.envInfo.pro + '/author/info.jsonp', {
          params: {
            authorId: this.authorId
          }
        })
        if(response && response.body && response.body.code === 0){
          this.dataLoaded = true;
          // console.log(response.body);
          this.author = response.body.author;
          document.title = this.author.name;
          this.setShareConfig();
        }else{
          console.log('获取作者详情错误');
        }
      } catch (error) {
        console.log(error);
      }
    },
    async getBooks(){
      try {
        const response = await this.$http.jsonp(this.envInfo.pro + '/author/books.jsonp', {
          params: {
            authorId: this.authorId,
            pageSize: 3
          }
        })
        if(response && response.body && response.body.code === 0){
          // console.log(response.body);
          this.books = response.body.bookWrappers;
          this.bookCount = response.body.totalCount;
        }else{
          console.log('获取作者书籍错误');
        }
      } catch (error) {
        console.log(error);
      }
    },
    copyHandler(){
      this.log.sendLog('a9-5', ['author_page', 'copy_invitecode_author', this.authorId])
    },
    downloadLogHandler(){
      this.log.sendLog('a9-4', ['author_page', 'download', this.authorId])
    },
    formatNumber(number){
      return customFormatNumber(number);
    },
    bookClickHandler(bookId){
      this.log.sendLog('a9-2', ['author_page', 'click_book', bookId]);
      setTimeout(() => {
        location.href = `/share/book/${bookId}`;
      }, 300);
    },
    openClickHandler(){
      this.log.sendLog('a9-3', ['author_page', 'view_more', this.authorId]);
      setTimeout(() => {
        this.openApp();
      }, 300);
    }
  }
}
</script>

<style lang="scss">
  html,body{
    height: 100%;
  }
  body{
    background: #fff;
  }
  @import '../../../css/component/reset.css';
  @import '../style/author.css';
</style>
